import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { IndividuService } from '@Common/core/services';
import { Observable } from 'rxjs';
import { roles } from '../enum/roles';


@Injectable()
export class SuperviseurGuardService  {
  constructor(private individuService: IndividuService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.isSupergestionnaire();
  }

  private isSupergestionnaire(): Observable<boolean> {
    return new Observable(observer => {
      this.individuService.individu$.subscribe(_individu => {
          const isStaff = this.isStaff(_individu);
          if ( !isStaff) {
            this.router.navigateByUrl('/forbidden');
          }
          observer.next(isStaff);
          observer.complete();
        }
      );
    });
  }

  private isStaff(individu) {
    return this.individuService.hasRole(individu, roles.admin) ||
      this.individuService.hasRole(individu, roles.superviseur);
  }
}
